
$dependencyManager.addDependencyCallback('gsap', () => {

  function openPaymentMethod(methodName, animate=true) {
  
    let paymentMethodBox = jQuery(`.mad-checkout-payment__payment-method-box[data-payment-method="${methodName}"]`)
    
    let boxHeight = 0;

    for (const child of paymentMethodBox.children()) {
      boxHeight = boxHeight + jQuery(child).outerHeight(true);
    }

    if (animate) {
      gsap.to(paymentMethodBox, {
        height: boxHeight,
        duration: 0.4
      })
      gsap.set(paymentMethodBox, {
        height: 'fit-content',
        delay: 0.5
      })
    } else {
      gsap.set(paymentMethodBox, {
        height: 'fit-content',
      })
    }
  }
  
  function closeAllPaymentMethods(skipMethodName) {
  
    jQuery(`.mad-checkout-payment__payment-method-box`).each((i, paymentMethodBox) => {
      if (jQuery(paymentMethodBox).attr('data-payment-method') != skipMethodName) {
        
        gsap.set(paymentMethodBox, {
          height: jQuery(paymentMethodBox).outerHeight(),
        })

        gsap.to(paymentMethodBox, {
          height: 0,
          duration: 0.4
        })
      }

    })

  }
  
  
  jQuery('.mad-checkout-payment__payment-method').each((i, methodContainer) => {
    var input = jQuery(methodContainer).find('> input[name="payment_method"]').get(0)
  
    jQuery(input).change((event) => {
      var input = event.target
      var isChecked = input.checked
      var methodName = jQuery(input).parent().attr('data-payment-method')
      
      if (isChecked) {
        closeAllPaymentMethods(methodName)
        if (methodName != null) {
          openPaymentMethod(methodName)
        }
      }
    })
  })
  
  setTimeout(() => {
    jQuery('.mad-checkout-payment__payment-method').each((i, methodContainer) => {
      var input = jQuery(methodContainer).find('> input[name="payment_method"]')
      if (!input.length) return;
      
      var inputElement = input.get(0)
      var isChecked = inputElement.checked
      var methodName = jQuery(input).parent().attr('data-payment-method')
      if (isChecked && methodName != null) {
        openPaymentMethod(methodName, animate=false)
      }
    })
  }, 300)

})